import "./index.scss";
import { AuthTokenProvider } from "~/ad-authentication";
import { ProductCatalogUIInitializer } from "./Init";
import { VssNavigation } from "./navigation";
import { ProductCatalogUIContext } from "./ProductCatalogUIContext";
import { Config } from "~/config";
import { Metrics } from "~/metrics";
import { Config as ConfigShared, Metrics as MetricsShared, AuthTokenProvider as AuthTokenProviderShared } from "shared-components";

ProductCatalogUIInitializer.initialize();
ConfigShared.setConfig(Config);
MetricsShared.setMetrics(Metrics);
AuthTokenProviderShared.setTokenProvider(AuthTokenProvider);

if (window.parent.location === window.location) {
    ProductCatalogUIContext.isStandaloneUI = true;

    void renderPage();
} else {
    ProductCatalogUIContext.isStandaloneUI = false;

    VSS.init({
        usePlatformScripts: false,
        usePlatformStyles: false,
    });

    VSS.ready(() => {
        const onReady = async () => {
            ProductCatalogUIContext.isStandaloneUI = false;
            if (VSS.isMock !== undefined) {
                ProductCatalogUIContext.isStandaloneUI = VSS.isMock;
            }
            await VssNavigation.bridgeVssNavigation();
            await renderPage();
        };

        void onReady();
    });
}

 async function renderPage() {
    try {
        const isTokenRenewalInProgress =
            await AuthTokenProvider.isTokenRenewalInProgress();
        if (isTokenRenewalInProgress) {
            await AuthTokenProvider.handleWindowCallback();
        } else {
            await AuthTokenProvider.authenticateUser();
            AuthTokenProvider.queueTokenRequestForUsedResourceIds();
            
            const AuthenticatedPage = await import(
                /* webpackChunkName: "AuthenticatedPage" */ "./AppIndex/AuthenticatedPage"
            );
            AuthenticatedPage.renderAuthenticatedPage();
        }
    } catch (error) {
        // Do nothing (render blank page)
    }
}
